import { LibService } from './../libService';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './../base.service';
import { UserSessionService } from './../user-session.service';
import { GuardService } from './../guard.service';
import { AuthService } from '../../auth/auth.service'
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class ConsuntivatoreDubaiService extends BaseService {

    constructor(
        public LibService: LibService,
        public AuthService: AuthService,
        public userSessionService: UserSessionService,
        public guardService: GuardService
    ) {
        super(LibService, AuthService)
        this.baseApi = environment.rootApiFinance;
        this.model = ''
    }
    get headers(): HttpHeaders {
        const headersConfig = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };

        return new HttpHeaders(headersConfig);
    }

    getOperators(
        userToken: string,
        email: string,
        country: string,
        idProfilo: string[],
        idSede?: string | null,
        idSocieta?: string | null
    ): Observable<any> {
        let query = `/V1/output/GetConsuntivazioneRisorse?account=${email}&country=${country}&idProfilo=${idProfilo}`;

        // Se il valore è undefined, NON lo passo.
        // Se è null, passo null (verrà visualizzato &idSede=null)
        if (typeof idSede !== 'undefined') query += `&idSede=${idSede}`;
        if (typeof idSocieta !== 'undefined') query += `&idSocieta=${idSocieta}`;

        return this.libService.getDataWithAccessToken<any>(
            userToken,
            this.baseApi,
            query
        );
    }

    getCountry(userToken: string, email: string): Observable<any> {
        const url = `/V1/output/GetCountry?account=${email}`;
        return this.libService.getDataWithAccessToken<any>(
            userToken,
            this.baseApi,
            url
        );
    }

    getSocieta(userToken: string, email: string, country?: string): Observable<any> {
        let url = `/V1/output/GetSocietaV2?account=${email}`;
        if (country) url += `&country=${country}`;
        return this.libService.getDataWithAccessToken<any>(
            userToken, this.baseApi, url
        );
    }

    getSedi(userToken: string, email: string, country?: string, societa?: string): Observable<any> {
        let url = `/V1/output/GetSediV2?account=${email}`;
        if (country) url += `&country=${country}`;
        if (societa) url += `&societa=${societa}`;
        return this.libService.getDataWithAccessToken<any>(
            userToken, this.baseApi, url
        );
    }


    getOperators2(userToken: string, email: string): Observable<any> {
        return this.libService.getDataWithAccessToken<any>(userToken, this.baseApi, `/V1/output/getOperai?account=${email}`);
    }

    getConsuntivazioneDubai(
        userToken: string,
        email: string,
        parametro?: string,
        country?: string,
        societa?: string,
        sede?: string
    ): Observable<any> {
        let url = `/V1/output/GetCommesseConsuntivazioneDubai?account=${email}`;
    
        if (parametro && parametro.trim() !== '') {
            url += `&parametro=${encodeURIComponent(parametro.trim())}`;
        }
        if (country) {
            url += `&country=${encodeURIComponent(country)}`;
        }
        if (societa) {
            url += `&societa=${encodeURIComponent(societa)}`;
        }
        if (sede) {
            url += `&sede=${encodeURIComponent(sede)}`;
        }
    
        return this.libService.getDataWithAccessToken<any>(
            userToken,
            this.baseApi,
            url
        );
    }
    

    setConsuntivazioneDubaiAssociazionePraticaOperatore(
        userToken: string,
        email: string,
        associazioni: { practiceId: number; WorkerId: number }[]
    ): Observable<any> {
        const url = `/V1/input/SetConsuntivazioneDubaiAssociazionePraticaOperatore?account=${email}`;
        const enrichedAssociazioni = associazioni.map(a => ({
            ...a,
            isScanned: null
        }));
        const payload = {
            practicesTeamLeaders: enrichedAssociazioni
        };
        return this.libService.postDataWithAccessToken<any>(
            userToken,
            payload, // ✅ ora è un array
            this.baseApi,
            url
        );
    }


    deleteConsuntivazioneDubaiAssociazionePraticaOperatore(
        userToken: string,
        email: string,
        practiceId: number,
        WorkerId: number
    ): Observable<any> {
        const url = `/V1/delete/DeleteConsuntivazioneDubaiAssociazionePraticaOperatore?account=${email}`;

        // 🔹 Dati da inviare
        const body = {
            practiceId: practiceId,
            WorkerId: WorkerId
        };

        return this.libService.postDataWithAccessToken<any>(
            userToken,    // 🔹 Token di autenticazione
            body,         // 🔹 Corpo della richiesta JSON
            this.baseApi, // 🔹 URL base della API
            url           // 🔹 Endpoint specifico
        );
    }

    getCommesseConsuntivazioneDubai(userToken: string, email: string): Observable<any> {
        const url = `/V1/output/GetCommesseConsuntivazioneOperai?account=${email}`;

        return this.libService.getDataWithAccessToken<any>(
            userToken,    // 🔹 Token di autenticazione
            this.baseApi, // 🔹 URL base della API
            url           // 🔹 Endpoint specifico
        );
    }

}